var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"emailTemplateBuilder"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header d-flex"},[_c('div',{staticClass:"col-2 col-sm-3 order-1 order-sm-0"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 order-0 order-sm-1"},[_c('h4',{staticClass:"pt-2 mb-0 pb-1 text-center"},[_c('span',{staticClass:"popup-name",on:{"click":_vm.editName}},[_vm._v("Email Template: "+_vm._s(_vm.templateName))])])]),_vm._v(" "),_c('div',{staticClass:"col-10 col-sm-3 order-2 order-sm-2 pr-0"},[_c('ul',{staticClass:"nav nav-pills card-header-pills justify-content-end w-100"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"btn btn-primary mr-1",attrs:{"href":"#","title":"Save"},on:{"click":_vm.saveTemplate}},[_c('i',{staticClass:"fa fa-save"})])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Layout Editor","active":""}},[_c('editor',{attrs:{"api-key":"obip02r8no4uqkvy6x0salyqznd0lmjfq2oea5ro2symfsuc","init":{
         height: 'calc(100vh - 300px)',
         menubar: false,

         plugins: [
         'fullpage',
           'advlist autolink lists link image charmap print preview anchor',
           'searchreplace visualblocks code fullscreen',
           'insertdatetime media table paste code help wordcount'
         ],
         toolbar: [
           'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help | code ',
           'shortcodeMenuContact | mergeTagsMenu | otherTagsMenu'
           ],

          setup: function (editor) {
            var toggleState = false;
        

            /* Contact Shortcode Menu Start */
            
            editor.ui.registry.addMenuButton('shortcodeMenuContact', {
              text: 'Contact Replacements',
              fetch: function (callback) {
                var items = [
                  {
                    type: 'menuitem',
                    text: 'First Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts first name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[firstname fallback="'+data.fallback+'"]');
                                    editor.windowManager.close();
                                },
                            });

                        },
                        onAction: function(){ editor.insertContent('[firstname]'); editor.windowManager.close(); },
                        });
                    }

                  },{
                    type: 'menuitem',
                    text: 'Last Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts last name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[lastname fallback="'+data.fallback+'"]');
                                    editor.windowManager.close();
                                },
                            });



                        },
                        onAction: function(){ editor.insertContent('[lastname]'); editor.windowManager.close(); },
                        });
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Name',
                    onAction: function () {
                        editor.windowManager.open({
                        title: 'Dialog Title', // The dialog's title - displayed in the dialog header
                        body: {
                            type: 'panel', // The root body type - a Panel or TabPanel
                            items: [ // A list of panel components
                                {
                                    type: 'htmlpanel', // A HTML panel component
                                    html: 'Would you like to set a fallback value in case the contacts company name is missing?'
                                }
                            ]
                        },
                        buttons: [
                            {
                                type: 'submit',
                                text: 'Yes'
                            },
                            {
                                type: 'custom',
                                text: 'No'
                            }
                        ],
                        onSubmit: function(){ 


                            editor.windowManager.close(); // Close current dialog
                            editor.windowManager.open({
                                title: 'Fallback Text', // The dialog's title - displayed in the dialog header
                                body: {
                                    type: 'panel', // The root body type - a Panel or TabPanel
                                    items: [ // A list of panel components
                                        {
                                            type: 'input', // component type
                                            name: 'fallback', // identifier
                                            inputMode: 'text',
                                            placeholder: '', // placeholder text for the input
                                            disabled: false, // disabled state
                                            maximized: false // grow width to take as much space as possible
                                        }
                                    ]
                                },
                                buttons: [
                                    {
                                        type: 'submit',
                                        text: 'Insert'
                                    }
                                ],
                                onSubmit: function(dialogApi){ 
                                    var data = dialogApi.getData();
                                    editor.insertContent('[company fallback="'+data.fallback+'"]');
                                    editor.windowManager.close();
                                },
                            });



                        },
                        onAction: function(){ editor.insertContent('[company]'); editor.windowManager.close(); },
                        });
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email (linked)',
                    onAction: function () {
                      editor.insertContent('[email]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email (not-linked)',
                    onAction: function () {
                      editor.insertContent('[emailaddress]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Phone Number',
                    onAction: function () {
                      editor.insertContent('[telephone]');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Contact Shortcode Menu End */

            /* Merge Tags Menu Start */
            
            editor.ui.registry.addMenuButton('mergeTagsMenu', {
              text: 'Merge Tags',
              fetch: function (callback) {
                var items = [
                {
                    type: 'menuitem',
                    text: 'Email Subject',
                    onAction: function () {
                      editor.insertContent('*|SUBJECT|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Preheader',
                    onAction: function () {
                      editor.insertContent('*|PREHEADER|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Message',
                    onAction: function () {
                      editor.insertContent('*|BODY|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Button Text',
                    onAction: function () {
                      editor.insertContent('*|BUTTON|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Email Footer',
                    onAction: function () {
                      editor.insertContent('*|BODY|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 1',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_1|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 2',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_2|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 3',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_3|*');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Custom Field 4',
                    onAction: function () {
                      editor.insertContent('*|CUSTOM_4|*');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Merge Tags Menu End */

         /* Other Tags Menu Start */
            
            editor.ui.registry.addMenuButton('otherTagsMenu', {
              text: 'Other Tags',
              fetch: function (callback) {
                var items = [
                  {
                    type: 'menuitem',
                    text: 'Unsubscribe (Linked Text)',
                    onAction: function () {
                      editor.insertContent('[unsubscribe]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Unsubscribe (URL)',
                    onAction: function () {
                      editor.insertContent('[unsubscribe_url]');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Logo',
                    onAction: function () {
                      editor.insertContent('{email_logo}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Logo (Linked)',
                    onAction: function () {
                      editor.insertContent('{email_linked_logo}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Company Colour',
                    onAction: function () {
                      editor.insertContent('{accent}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Link to SizzleDeck',
                    onAction: function () {
                      editor.insertContent('{link}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender First Name',
                    onAction: function () {
                      editor.insertContent('{first_name}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Last Name',
                    onAction: function () {
                      editor.insertContent('{last_name}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Position',
                    onAction: function () {
                      editor.insertContent('{position}');
                    }
                  },{
                    type: 'menuitem',
                    text: 'Sender Company Name',
                    onAction: function () {
                      editor.insertContent('{company_name}');
                    }
                  }
                ];
                 callback(items);
              }
            });

            /* Other Tags Menu End */


           }

       }},model:{value:(_vm.layout),callback:function ($$v) {_vm.layout=$$v},expression:"layout"}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Defaults & Merge Tags"}},[_c('p',[_vm._v("Email templates can use the following merge tags, the defaults for which can be defined below:")]),_vm._v(" "),_c('form',{ref:"emailpreviewform",attrs:{"action":"/email/builder-preview","method":"POST","target":"builderPreview"}},[_c('input',{attrs:{"type":"hidden","name":"layout"},domProps:{"value":_vm.layout}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"preview_type"},domProps:{"value":_vm.previewType}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"_token"},domProps:{"value":_vm.csrf}}),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Email Subject *|SUBJECT|*"}},[_c('b-input',{attrs:{"name":"default_subject","type":"text"},model:{value:(_vm.mergeTags.subject),callback:function ($$v) {_vm.$set(_vm.mergeTags, "subject", $$v)},expression:"mergeTags.subject"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Email Preheader *|PREHEADER|*"}},[_c('b-input',{attrs:{"name":"default_preheader","type":"text"},model:{value:(_vm.mergeTags.preheader),callback:function ($$v) {_vm.$set(_vm.mergeTags, "preheader", $$v)},expression:"mergeTags.preheader"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Email Message *|BODY|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.body),callback:function ($$v) {_vm.$set(_vm.mergeTags, "body", $$v)},expression:"mergeTags.body"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.body),expression:"mergeTags.body"}],attrs:{"name":"default_body","type":"hidden"},domProps:{"value":(_vm.mergeTags.body)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "body", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Button Text *|BUTTON|*"}},[_c('b-input',{staticClass:"w-2",attrs:{"name":"default_button","type":"text"},model:{value:(_vm.mergeTags.button),callback:function ($$v) {_vm.$set(_vm.mergeTags, "button", $$v)},expression:"mergeTags.button"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Email Footer *|FOOTER|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.footer),callback:function ($$v) {_vm.$set(_vm.mergeTags, "footer", $$v)},expression:"mergeTags.footer"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.footer),expression:"mergeTags.footer"}],attrs:{"name":"default_footer","type":"hidden"},domProps:{"value":(_vm.mergeTags.footer)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "footer", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Custom Field 1 *|CUSTOM_1|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.custom_1),callback:function ($$v) {_vm.$set(_vm.mergeTags, "custom_1", $$v)},expression:"mergeTags.custom_1"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.custom_1),expression:"mergeTags.custom_1"}],attrs:{"name":"default_custom_1","type":"hidden"},domProps:{"value":(_vm.mergeTags.custom_1)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "custom_1", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Custom Field 2 *|CUSTOM_2|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.custom_2),callback:function ($$v) {_vm.$set(_vm.mergeTags, "custom_2", $$v)},expression:"mergeTags.custom_2"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.custom_2),expression:"mergeTags.custom_2"}],attrs:{"name":"default_custom_2","type":"hidden"},domProps:{"value":(_vm.mergeTags.custom_2)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "custom_2", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Custom Field 3 *|CUSTOM_3|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.custom_3),callback:function ($$v) {_vm.$set(_vm.mergeTags, "custom_3", $$v)},expression:"mergeTags.custom_3"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.custom_3),expression:"mergeTags.custom_3"}],attrs:{"name":"default_custom_3","type":"hidden"},domProps:{"value":(_vm.mergeTags.custom_3)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "custom_3", $event.target.value)}}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mx-auto",attrs:{"label":"Custom Field 4 *|CUSTOM_4|*"}},[_c('tiptap',{model:{value:(_vm.mergeTags.custom_4),callback:function ($$v) {_vm.$set(_vm.mergeTags, "custom_4", $$v)},expression:"mergeTags.custom_4"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mergeTags.custom_4),expression:"mergeTags.custom_4"}],attrs:{"name":"default_custom_4","type":"hidden"},domProps:{"value":(_vm.mergeTags.custom_4)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.mergeTags, "custom_4", $event.target.value)}}})],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b-select',{attrs:{"options":[{value:'dummy-contact',text:'Preview using dummy contact info'},{value:'no-contact',text:'Preview using fallbacks'}]},model:{value:(_vm.previewType),callback:function ($$v) {_vm.previewType=$$v},expression:"previewType"}}),_vm._v(" "),_c('iframe',{staticClass:"mt-1 w-100 border rounded",staticStyle:{"min-height":"calc(100vh - 300px)"},attrs:{"id":"builderPreview","name":"builderPreview"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Please note: An unsubscribe link MUST be included on all emails. If one is not included in your template, one will be added automatically.")])],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"emailTemplateName","title":"Edit Template Name"},on:{"ok":_vm.setName}},[_c('b-input',{model:{value:(_vm.tempTemplateName),callback:function ($$v) {_vm.tempTemplateName=$$v},expression:"tempTemplateName"}})],1),_vm._v(" "),_c('b-modal',{ref:"modalStart",attrs:{"id":"modalStart","size":"lg","hide-footer":true,"hide-header":true,"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":""}},[_c('h5',[_vm._v("Start from Scratch:")]),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"Email Template Name"}},[_c('b-form-input',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.setNameStart.apply(null, arguments)}},model:{value:(_vm.tempTemplateName),callback:function ($$v) {_vm.tempTemplateName=$$v},expression:"tempTemplateName"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.setNameStart}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col"},[_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-auto col-auto pt-1 text-muted"},[_vm._v("OR")]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('hr')])]),_vm._v(" "),_c('h5',[_vm._v("Import Email Template from Library:")]),_vm._v(" "),_c('b-input-group',[_c('b-form-select',{attrs:{"options":_vm.availableTemplates},model:{value:(_vm.templateToImport),callback:function ($$v) {_vm.templateToImport=$$v},expression:"templateToImport"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.importTemplate}},[_vm._v("Import")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }